export function sidebarMenu() {
    (function($) {
        //Function for Ajax Load More Listing items
        //new AjaxLoadMore();
        let windowWidth = $(window).width();
        $('#menu-menu-in-sidebar li a').click(function(e) {
            if($(this).closest('li').hasClass('has_menu_shortcode')){
                e.preventDefault(); // Previeni il comportamento predefinito del link
                let menuText = $(this).text();
                if(windowWidth > 1280){
                    var $slidingDiv = $('#container-for-template');
                    if($slidingDiv.hasClass('expanded')){
                        $slidingDiv.css({
                            'transform' : 'translateX(-140%)',
                            'transition': 'all ease 0.5s'
                        })
                        $slidingDiv.removeClass('expanded');
                    }
                }else{
                    var $slidingDiv = $('.right_content');
                    if($slidingDiv.hasClass('expanded')){
                        $slidingDiv.css({
                            'transform' : 'translateX(-100%)',
                            'transition': 'all ease 0.5s'
                        })
                        $slidingDiv.removeClass('expanded');
                    }
                }

                console.log(menuText);
                // Esegui la richiesta AJAX
                $.ajax({
                    url: ajax_object.ajax_url, // La variabile ajax_url è fornita da WordPress
                    type: 'post',
                    data: {
                        action: 'load_template_part',
                        menu_text: menuText,
                    },
                    success: function(response) {
                        $('#container-for-template').html(response);
                        // Inserisci il contenuto della risposta nel tuo container desiderato
                        if(windowWidth > 1280){
                            let $slidingDiv = $('#container-for-template');
                            $slidingDiv.css({
                                'transform' : 'translateX(0%)',
                                'transition': 'all ease 0.5s'
                            })
                            $slidingDiv.addClass('expanded');
                        }else{
                            let $slidingDiv = $('.right_content');
                            $slidingDiv.css({
                                'transform' : 'translateX(0%)',
                                'transition': 'all ease 0.5s'
                            })
                            $slidingDiv.addClass('expanded');
                        }
                        //$("#container-for-template").addClass('expanded');
                        //$(".sidebar_menu_container").toggleClass('expanded');

                        $('#pills-tab-menuContent .navs-container').hide();
                        setTimeout(function(){
                            //Menu taxonomy carousel
                            let terms_carousel_competence = $('#terms_menu_carousel-competence_area');
                            if(terms_carousel_competence.length > 0){
                                $('#terms_menu_carousel-competence_area').owlCarousel({
                                    loop:false,
                                    items:1,
                                    margin:20,
                                    dots:true,
                                    nav:false,

                                    // Posiziona i puntini nel loro container
                                    dotsContainer: '#dots_container-competence_area'
                                })
                                 // Aggiungi manualmente i pulsanti 'prev' e 'next' nei rispettivi container
                                let owlInstance = $('#terms_menu_carousel-competence_area').data('owl.carousel');

                                $('#pills-menu-competence_area .custom-prev-container span').on('click', function () {
                                    owlInstance.prev();
                                });

                                $('#pills-menu-competence_area .custom-next-container span').on('click', function () {
                                    owlInstance.next();
                                });

                                if($('#pills-tab-menuContent #dots_container-competence_area').hasClass('disabled')){
                                    $('#pills-tab-menuContent .navs-container#navs_container-competence_area').hide();
                                }else{
                                    $('#pills-tab-menuContent .navs-container#navs_container-competence_area').show();
                                }
                            }
                            let terms_carousel_international = $('#terms_menu_carousel-international_focus_group');
                            if(terms_carousel_international.length > 0){
                                $('#terms_menu_carousel-international_focus_group').owlCarousel({
                                    loop:false,
                                    items:1,
                                    margin:20,
                                    dots:true,
                                    nav:false,

                                    // Posiziona i puntini nel loro container
                                    dotsContainer: '#dots_container-international_focus_group'
                                })
                                 // Aggiungi manualmente i pulsanti 'prev' e 'next' nei rispettivi container
                                let owlInstance = $('#terms_menu_carousel-international_focus_group').data('owl.carousel');

                                $('#pills-menu-international_group .custom-prev-container span').on('click', function () {
                                    owlInstance.prev();
                                });

                                $('#pills-menu-international_group .custom-next-container span').on('click', function () {
                                    owlInstance.next();
                                });

                                if($('#pills-tab-menuContent #dots_container-international_focus_group').hasClass('disabled')){
                                    $('#pills-tab-menuContent .navs-container#navs_container-international_focus_group').hide();
                                }else{
                                    $('#pills-tab-menuContent .navs-container#navs_container-international_focus_group').show();
                                }
                            }

                            if (typeof a2a !== 'undefined' && a2a.init) {
                                a2a.init('page', {
                                    onclick: 1,
                                    num_services: 4,
                                    prioritize: ['whatsapp', 'facebook', 'twitter', 'copy_link']
                                    // Additional instance configs can be set here
                                });
                            }
                        }, 1500)
                        
                        
                        $('.back_arrow').click(function(){
                            console.log('click')
                            if ($(window).width() < 1280) {
                                //$(".sidebar_menu_container").toggle("slide");
                                $("#container-for-template").toggleClass('expanded');
                                $slidingDiv.css({
                                    'transform' : 'translateX(-100%)',
                                    'transition': 'all ease 0.5s'
                                })
                                $slidingDiv.removeClass('expanded');
                            }
                        })
                
                    },
                    error: function(error) {
                        console.log(error);
                    }
                });
            }else{
                $('#container-for-template').html('');
            }
        });
        $('.offcanvas-header button.btn-close').click(function(){
            //$(".sidebar_menu_container").toggle("slide");

            if(windowWidth > 1280){
                var $slidingDiv = $('#container-for-template');
                if($slidingDiv.hasClass('expanded')){
                    $slidingDiv.css({
                        'transform' : 'translateX(-140%)',
                        'transition': 'all ease 0.5s'
                    })
                    $slidingDiv.removeClass('expanded');
                }
            }else{
                var $slidingDiv = $('.right_content');
                if($slidingDiv.hasClass('expanded')){
                    $slidingDiv.css({
                        'transform' : 'translateX(-100%)',
                        'transition': 'all ease 0.5s'
                    })
                    $slidingDiv.removeClass('expanded');
                }
            }
            $('#container-for-template').html('');
        })

    })(jQuery);
}